<template>
  <Modal
    class="switch-team-modal"
    v-model="visible"
    :title="$t('global.text3')"
    width="560"
  >
    <div class="switch-team-modal-body">
      <Spin size="large" fix v-if="loading"></Spin>
      <Tooltip
        v-for="(v, i) in teams"
        placement="left"
        :key="`tip_${i}`"
        :content="v.name"
        style="width: 100%"
        @click.native="onChange(v)"
      >
        <Row
          class="team-list cur-p"
          type="flex"
          align="middle"
          justify="space-between"
          @click.native="onChange(v)"
        >
          <Row type="flex" align="middle" style="flex: 1">
            <Avatar :size="38" v-if="v.logo" :src="v.logo" circle></Avatar>
            <Avatar
              :size="38"
              v-else
              style="background: rgb(186, 217, 255)"
              circle
            >
              {{ $substrName(v.name) }}
            </Avatar>
            <Badge :count="v.todoCount">
              <span style="display: inline-block" class="team-name text-hide">
                {{ v.name }}
              </span>
            </Badge>
          </Row>
          <Radio :value="v.id === teamId"></Radio>
        </Row>
      </Tooltip>
    </div>
    <Row style="margin-top: 20px" justify="end">
      <Page
        @on-change="onChangePage"
        :current="filter.page + 1"
        :page-size="filter.size"
        :total="total"
        simple
      />
    </Row>

    <Row type="flex" justify="end" slot="footer" class="footer-dialog">
      <Button
        @click.native="visible = false"
        style="margin-right: 24px; width: 118px"
      >
        {{ $t('btn.cancel') }}
      </Button>
      <Button
        style="width: 118px"
        type="primary"
        :loading="submitLoading"
        @click.native="onSaveTeam"
      >
        {{ $t('btn.done') }}
      </Button>
    </Row>
  </Modal>
</template>

<script>
import jsonwebtoken from 'jsonwebtoken';
import { AuthManage } from '@/plugins/auth';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      visible: false,
      loading: true,
      teams: [],
      total: 0,
      filter: { page: 0, size: 6 },
      selected: null,
      submitLoading: false
    };
  },
  computed: {
    teamId() {
      return this.selected ? this.selected.id : localStorage.getItem('teamId');
    }
  },
  methods: {
    ...mapMutations({
      set_team: 'set_team',
      set_self: 'set_self'
    }),
    show() {
      this.visible = true;
      this.getTeams();
    },
    onChangePage(e) {
      this.filter.page = e - 1;
      this.getTeams();
    },
    async getTeams() {
      try {
        this.loading = true;
        const res = await this.$http('get', 'mobile/t/teams', this.filter);
        this.teams = res.data.content;
        this.total = res.data.totalElements;
        const find = _.find(this.teams, (f) => f.id === this.teamId);
        this.selected = find;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    onChange(e) {
      this.selected = e;
    },
    async onSaveTeam() {
      const e = this.selected;
      if (e) {
        this.submitLoading = true;
        this.set_team(e);
        localStorage.setItem('teamId', e.id);
        this.submitLoading = false;
        this.$router.replace('/');
        setTimeout(() => {
          location.reload();
        }, 50);
      } else {
        this.visible = false;
      }
    }
  }
};
</script>
<style lang="less">
.switch-team-modal {
  .switch-team-modal-body {
    min-height: 200px;
  }

  .team-list {
    padding: 10px 0;
    box-shadow: 0px 1px 0px 0px #dee0e3;

    .team-name {
      font-size: 16px;
      font-weight: 400;
      color: #1f2329;
      line-height: 22px;
      max-width: 360px;
      margin-left: 16px;
      margin-right: 20px;
    }
  }

  .footer-dialog {
    margin-top: 20px;
  }

  .ivu-page {
    display: inline-block;
  }
}
</style>
